import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import React from "react";

export default function DeleteShiftInlineDialog({ openDeleteShiftDialog, handleShiftDelete, handleClose, performerName }) {

    return (
        <Dialog open={openDeleteShiftDialog} onClose={handleClose}>
            <DialogTitle sx={{ textAlign: 'left' }}>Delete Generated Shift</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ textAlign: 'left' }}>
                    Are you sure you want to delete <strong>{performerName}'s</strong> shift?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button sx={{ marginBottom: '0.2rem', marginRight: '0.9rem' }} variant="contained" color="primary" onClick={handleClose} >
                    Cancel
                </Button>
                <Button sx={{ marginBottom: '0.2rem', marginRight: '0.9rem' }} variant="contained" color="primary" onClick={handleShiftDelete}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}